import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';

import useCopyClick from '../../hooks/useCopyClick';
import { useShare } from '../../providers/share';

import CloseIcon    from '../icons/CloseIcon';
import CopyLinkIcon from '../icons/CopyLinkIcon';

const ShareModal = function() {
  const { t } = useTranslation();

  const [isCopied, onCopy] = useCopyClick();
  const share              = useShare();

  const modalRef = React.useRef(null);

  const [bookmarksLink, setBookmarksLink] = React.useState(() => {
    if (share.link.length) {
      return share.link;
    } else {
      return t('client_bookmarks_clear');
    }
  });
  const [show, setShow]                   = React.useState(false);

  const closeModal         = React.useCallback(() => {
    setShow(false);

    share.hideModal();
  }, [show]);
  const handleClickOutside = React.useCallback((event) => {
    if (
      share.open &&
      modalRef.current &&
      !modalRef.current.contains(event.target)
    ) {
      closeModal();
    }
  }, [share.open, closeModal]);
  const keyDown            = React.useCallback((event) => {
    if (share.open && show && event.key === 'Escape') {
      closeModal();
    }
  }, [closeModal, share.open, show]);

  React.useEffect(() => {
    if (share.link.length) {
      setBookmarksLink(share.link);
    } else {
      setBookmarksLink(t('client_bookmarks_clear'));
    }
  }, [share.link]);
  React.useEffect(() => {
    if (share.open) {
      if (!show) {
        setTimeout(() => {
          setShow(true);
        }, 1e2);
      }
    }
  }, [share.open]);
  React.useEffect(() => {
    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
      document.addEventListener('keydown', keyDown);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('keydown', keyDown);
    };
  }, [show]);
  React.useEffect(() => {
    document.body.classList.toggle('fixed', share.open && show);
  }, [share.open, show]);

  return (
    <div className={classNames('bookmarks_modal_overlay modal-overlay', { show })}>
      <div
        className={classNames('modal', 'bookmarks_modal')}
        ref={modalRef}
      >
        <span
          className={'close'}
          onClick={closeModal}
        ><CloseIcon /></span>
        <p className={'bookmarks_modal_title'}>{t('client_bookmarks_created')}</p>
        <div className={'bookmarks_modal_link_wrapper'}>
          <p className={'bookmarks_modal_text'}>{bookmarksLink ?? t('client_bookmarks_clear')}</p>
          <p className={'copy_text'}>{isCopied && t('client_copy')}</p>
          <button
            className={classNames('btn', 'fill', 'share_btn')}
            disabled={!bookmarksLink}
            onClick={() => {
              onCopy(bookmarksLink);
            }}
          ><CopyLinkIcon /></button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
